import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import FastRewind from 'react-icons/lib/md/fast-rewind';
import FastForward from 'react-icons/lib/md/fast-forward';
import FastBackward from '../../../assets/images/to-start-blue';
import Horizontal from '../../../assets/images/studio/horizontal';
import Vertical from '../../../assets/images/studio/vertical';
import {typoDark, white} from '../../../themes/colors';
import IconButton from '../../../components/iconButton/IconButton';
import SvgIconButton from '../../../components/SvgIconButton';
import PlayButton from "../../../components/playButton/PlayButton";

const defIconStyle = {
    fontSize: 24,
    width: '1em',
    height: '1em',
    fill: typoDark
};

const defButtonStyle = {
    height: '24px',
    minHeight: '24px',
    width: '24px',
    minWidth: '24px',
    borderRadius: 0,
    margin: 0
};

const StudioTopSkipBar = ({onSkip, disabled, forSoundSlice = false, leaderTrack, togglePlay, horizontalView, toggleHorizontalView, iconStyle, buttonStyle}) => {

    const mergedIconStyle = Object.assign({}, defIconStyle, iconStyle);
    const mergedButtonStyle = Object.assign({}, defButtonStyle, buttonStyle);


    const skipToStart = () => {
        onSkip('start');
    };

    const skipToNextBar = () => {
        onSkip('next');
    };
    const skipToPreviousBar = () => {
        onSkip('previous');
    };
    const handleKeyDown = (event) => {
        if (event.keyCode === 32) {
            event.preventDefault();
        }
    };
    return (
        <div className="center-controls" onKeyDown={handleKeyDown}>
            <SvgIconButton
                className="studio-skip-button backward" icon={FastBackward} viewBox="0 0 24 24" iconStyle={mergedIconStyle}
                style={{...mergedButtonStyle}} rippleColor={`rgba(${white} , .0)`} hoverColor={`rgba(${white} , .0)`} containerClass="center-btn" onClick={skipToStart} disabled={disabled}>
            </SvgIconButton>
            <IconButton
                className="studio-skip-button prev" style={mergedButtonStyle}
                disabled={disabled} rippleColor={`rgba(${white} , .0)`} hoverColor={`rgba(${white} , .0)`}
                containerClass="center-btn" onClick={skipToPreviousBar}>
                <FastRewind style={mergedIconStyle}/>
            </IconButton>
            {forSoundSlice && <PlayButton
                withProgress={false} onClick={togglePlay} status={leaderTrack.playStatus}
                id="looper-master-player" style={{minHeight: 40, minWidth: 40}}
                playerColor={mergedIconStyle.fill} track={leaderTrack} noBorder={true}/>
            }
            <IconButton
                className="studio-skip-button next" style={mergedButtonStyle}
                disabled={disabled} rippleColor={`rgba(${white} , .0)`} hoverColor={`rgba(${white} , .0)`}
                containerClass="center-btn" onClick={skipToNextBar}>
                <FastForward style={mergedIconStyle}/>
            </IconButton>
            {forSoundSlice &&
            <SvgIconButton
                className="controls-placeholder-icon" icon={horizontalView ? Horizontal : Vertical} viewBox="0 0 36 36" iconStyle={{...mergedIconStyle, fontSize: 24}}
                style={{...mergedButtonStyle}} rippleColor={`rgba(${white} , .0)`} hoverColor={`rgba(${white} , .0)`} containerClass="center-btn" onClick={toggleHorizontalView}
                disabled={disabled}>
            </SvgIconButton>
            }
        </div>
    );
};

StudioTopSkipBar.propTypes = {
    onSkip: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default observer(StudioTopSkipBar);
